import React, { useState, useRef, useEffect } from 'react';
import { ResponsiveContainer } from 'recharts';

// Composant wrapper ULTRA-SÉCURISÉ pour ResponsiveContainer - Version 2025
const SafeResponsiveContainer = ({ children, ...props }) => {
  const containerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 800, height: 300 }); // Valeurs par défaut fixes
  const timeoutRef = useRef(null);
  const isObservingRef = useRef(false);

  useEffect(() => {
    if (!containerRef.current || isObservingRef.current) return;

    // Fonction de mise à jour des dimensions avec débouncing ultra-agressif
    const updateDimensions = () => {
      if (!containerRef.current) return;
      
      try {
        const rect = containerRef.current.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) {
          const newDimensions = {
            width: Math.floor(rect.width),
            height: Math.floor(rect.height) || props.height || 300
          };
          
          setDimensions(prev => {
            if (Math.abs(prev.width - newDimensions.width) > 5 || 
                Math.abs(prev.height - newDimensions.height) > 5) {
              return newDimensions;
            }
            return prev;
          });
        }
      } catch (error) {
        // Ignore silencieusement les erreurs
      }
    };

    // Utiliser un timer au lieu de ResizeObserver pour éviter les boucles
    const startPolling = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      
      updateDimensions();
      
      timeoutRef.current = setTimeout(() => {
        if (containerRef.current && isObservingRef.current) {
          startPolling();
        }
      }, 250); // Polling toutes les 250ms
    };

    isObservingRef.current = true;
    
    // Délai initial pour laisser le temps au DOM de se stabiliser
    setTimeout(() => {
      if (containerRef.current) {
        updateDimensions();
        startPolling();
      }
    }, 100);

    return () => {
      isObservingRef.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [props.height]);

  // Nettoyage au démontage
  useEffect(() => {
    return () => {
      isObservingRef.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{ width: '100%', height: props.height || 300, minWidth: 300 }}
      className="safe-responsive-container"
    >
      <ResponsiveContainer
        {...props}
        width={dimensions.width || 800}
        height={dimensions.height || 300}
        minWidth={300}
      >
        {children}
      </ResponsiveContainer>
    </div>
  );
};

export { SafeResponsiveContainer };
